import { memo } from 'react';

import {
    type InputNumberProps as AntInputNumberProps,
    InputNumber as AntInputNumber,
} from 'antd';
import cn from 'classnames';

import cls from './input-number.module.css';

interface InputNumberProps extends AntInputNumberProps {
    isBlock?: boolean;
}

export const InputNumber = memo((props: InputNumberProps) => {
    const { isBlock, className, ...inputNumberProps } = props;

    return (
        <AntInputNumber
            {...inputNumberProps}
            className={cn(className, cls.root, { [cls.block]: isBlock })}
        />
    );
});

InputNumber.displayName = 'InputNumber';
